import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'eppProductsInList', standalone: true })
export class EppProductsInListPipe implements PipeTransform {
  transform(productList): Array<any> {
    const productName = 'epp';
    const parameterset = Object.keys(productList.epp)[0];
    if (parameterset && productList.epp.hasOwnProperty(parameterset)) {
      const res = Object.keys(productList.epp[parameterset])[0];
      if (
        productList.hasOwnProperty(productName) &&
        productList[productName].hasOwnProperty(parameterset) &&
        productList[productName][parameterset].hasOwnProperty(res)
      ) {
        return productList[productName][parameterset][res];
      }
    }
    return [];
  }
}
